import {
  __experimentalText as Text,
  __experimentalDivider as Divider,
  ToggleControl,
} from '@wordpress/components';
import ValidationToast from '@components/toast-validations';
import { validateField } from '@helpers/input-validations';

const {
  i18n: { __ },
} = wp;

const EmbedCode = ({
  embedCode,
  setAttributes,
  errors,
  setErrors,
  showToast,
  setShowToast,
}) => {
  let decodedVpopHtml = '';
  if (embedCode.content && embedCode.content.length > 0) {
    try {
      decodedVpopHtml = Buffer.from(embedCode.content, 'base64');
    } catch (error) {
      // ignore errors
    }
  }

  return [
    <>
      <div>
        <Text>{__('Embed code or HTML', 'b3rg')}</Text>
        <textarea
          placeholder={__('Paste the Embed code or HTML here', 'b3rg')}
          onChange={(event) => {
            const htmlInput = event.currentTarget.value;
            const isValid = validateField(
              'html',
              'embedCode',
              htmlInput,
              errors,
              setErrors,
              setShowToast,
            );
            if (isValid) {
              const htmlCodeEncoded = Buffer.from(htmlInput, 'utf-8').toString(
                'base64',
              );
              setAttributes({
                embedCode: {
                  ...embedCode,
                  content: htmlCodeEncoded,
                },
              });
            }
          }}
          onBlur={() => {
            setShowToast(false);
          }}
          rows="10"
          defaultValue={decodedVpopHtml}
        ></textarea>
        {showToast && errors.embedCode && (
          <ValidationToast type="error" message={errors.embedCode} />
        )}
      </div>
      <Divider />
      <ToggleControl
        label={__('Dismiss popup on click outside', 'b3rg')}
        checked={embedCode.dismissOnClick}
        onChange={(dismissOnClick) => {
          setAttributes({
            embedCode: {
              ...embedCode,
              dismissOnClick,
            },
          });
        }}
      />
    </>,
  ];
};

export default EmbedCode;
